import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["size", "color", "alignWithText", "aria-label", "id"];
// THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY.

import { useTheme } from 'foundations-theming/utils';
import { isCanvasTheme } from 'foundations-theming/utils';
import { useIconSize } from '../useIconSize';
import { StyledIcon } from '../StyledIcon';
import { getDataProps } from '../getDataProps';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
export const IntegrationsSurveyMonkeyIcon = _ref => {
  let {
      size: sizeProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      color: colorProp,
      // We don't set the default value here because we want to know if a consumer passed in a value
      alignWithText = false,
      'aria-label': ariaLabel,
      id
    } = _ref,
    restProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const theme = useTheme();
  const dataProps = getDataProps(restProps);
  const isCanvas = isCanvasTheme(theme);

  // Setting default values here
  const size = sizeProp !== null && sizeProp !== void 0 ? sizeProp : 'inherit';
  const color = colorProp !== null && colorProp !== void 0 ? colorProp : 'inherit';
  const sizeValue = useIconSize(size);
  const sizeCSSValue = sizeProp ? `${sizeValue} !important` : sizeValue; // Adds the `!important` flag to the `size` value if one is provided via props

  const colorValue = color === 'inherit' ? 'currentColor' : theme.color[color]; // inherit = currentColor = text color of the parent element
  const colorCSSValue = colorProp ? `${colorValue} !important` : colorValue; // Adds the `!important` flag to the `color` value if one is provided via props

  return /*#__PURE__*/_jsx(StyledIcon, Object.assign({}, dataProps, {
    $size: sizeCSSValue,
    $color: colorCSSValue,
    $alignWithText: alignWithText,
    "aria-label": ariaLabel,
    "aria-hidden": ariaLabel === undefined ? true : undefined,
    id: id,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 32 32",
    focusable: "false",
    "data-icon-name": "IntegrationsSurveyMonkey",
    children: isCanvas ? /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M26.68 17.01c-.28 0-.55.04-.81.1h.02c-1.03-3.96-4.27-6.93-8.3-7.56h-.06c-.08-.71.2-1.78 1.92-2.83l-.05-.11s-2.88.91-3.53 2.71c0-.56-.18-1.41-1.41-2 0 0-.1.04-.05.08.47.37.76.94.76 1.57 0 .17-.02.34-.06.5-4.35.38-7.89 3.47-8.95 7.56l-.02.07c-.24-.06-.51-.1-.79-.1h-.06c-1.82 0-3.3 1.48-3.3 3.3a3.303 3.303 0 0 0 4.59 3.04h-.02c.31.77.67 1.43 1.09 2.04l-.02-.03 2.75-1.83h-.04a6.7 6.7 0 0 1-1.24-3.65c-.02-.18-.03-.38-.03-.59 0-1.29.5-2.46 1.31-3.33 1.98-1.68 4.14-.91 5.49.71h.36c1.35-1.59 3.49-2.32 5.45-.66a4.85 4.85 0 0 1 1.25 3.84v-.02c-.05 1.4-.51 2.67-1.27 3.72v-.02l2.73 1.84c.4-.58.76-1.23 1.05-1.93l.02-.07c.36.15.79.24 1.23.24 1.82 0 3.3-1.48 3.3-3.3s-1.48-3.3-3.3-3.3h-.04ZM5.51 20.97a.66.66 0 1 1 0-1.32c.14 0 .27.04.38.11 0 .37.03.73.08 1.08v-.05c-.12.1-.28.17-.45.17Zm21.07 0c-.17 0-.33-.07-.45-.17.04-.31.06-.67.07-1.04.1-.08.23-.12.37-.12a.66.66 0 1 1 0 1.32Z"
      })
    }) : /*#__PURE__*/_jsx(_Fragment, {
      children: /*#__PURE__*/_jsx("path", {
        d: "M28.26 17.69c-.3 0-.59.05-.88.1a11.59 11.59 0 0 0-9.2-8.57c-.2-.05-.39-.05-.59-.1.05-1.08.1-2.36 1.72-3.49l-.3-.64s-3.14.98-3.49 3.68c-.15-.74-1.62-1.67-2.36-1.82l-.39.59c.64.39 1.08 1.08 1.18 1.82-4.54.78-8.12 4.15-9.25 8.57-2.01-.49-4.1.74-4.59 2.75s.74 4.1 2.75 4.59c.79.2 1.57.15 2.31-.15.34.78.74 1.57 1.23 2.26l3.14-2.11v-.05a7.6 7.6 0 0 1-1.42-4.2c-.1-1.72.34-3.44 1.42-4.44 2.26-1.91 4.74-1.03 6.31.78h.39c1.52-1.87 4-2.7 6.31-.78 1.08.98 1.52 2.7 1.42 4.44a7.67 7.67 0 0 1-1.42 4.2l-.05.05 3.14 2.11c.49-.69.88-1.47 1.23-2.26 1.92.74 4.15-.2 4.89-2.11s-.2-4.15-2.11-4.89c-.47-.25-.96-.34-1.38-.34ZM3.72 22.63c-.59-.05-1.08-.54-1.03-1.18.05-.59.49-1.03 1.03-1.08.24 0 .44.05.64.2 0 .59.05 1.18.1 1.77-.2.2-.44.3-.74.3Zm24.59 0c-.3 0-.54-.1-.74-.3.05-.59.1-1.18.1-1.77.49-.34 1.18-.2 1.52.3.15.2.2.39.2.64.05.64-.49 1.13-1.08 1.13"
      })
    })
  }));
};
IntegrationsSurveyMonkeyIcon.displayName = 'IntegrationsSurveyMonkeyIcon';